module.exports = __webpack_public_path__ + "static/media/logo-power.888d564b.png";